var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('div',{attrs:{"id":"core-view"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('div',{staticStyle:{"width":"100%","position":"fixed","bottom":"0px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }